var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:("cursor-pointer px-4 py-1 " + (_vm.color === 'primary'
        ? _vm.toggled
          ? 'bg-black-400 active:bg-black-400 text-white'
          : 'bg-black-200 active:bg-black-400 text-white'
        : _vm.toggled
        ? 'bg-gray-600 active:bg-gray-600 text-white'
        : 'bg-gray-700 active:bg-gray-600 text-white')),on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }